// general
//NOTE:  Please avoid any calls to versionCompare or ViewManager.
const CN = require('civicsUtils/constants');
const Utils = require('civicsUtils/general_utilities');
const Handlebars = require('handlebars');
const dompurify = require('dompurify');
const authorized_user_utils = require('civicsUtils/authorized_user_utils');

Handlebars.registerHelper('global:html', function (doc) {
  return new Handlebars.SafeString(doc);
});

Handlebars.registerHelper('global:compareEqual', function(a,b,options) {
	if(a == b){
		return options.fn(this);
	}
	else {
		return options.inverse(this);
	}
});
Handlebars.registerHelper('global:computedDescription', function(portalDescription, description) {
	if (typeof portalDescription === 'undefined') {
		portalDescription = '';
	}
	if (typeof description === 'undefined') {
		description = '';
	}

	var desc = portalDescription.trim().length >= 1 ? portalDescription.trim() : description.trim();
	desc = desc.length >= 1 ? desc : i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
	return desc;
});

Handlebars.registerHelper('global:contains', function(searchStr,searchItm, options){
	if(!_.isEmpty(searchStr) && !_.isEmpty(searchItm)){
		searchStr = searchStr.toLowerCase();
		searchItm = searchItm.toLowerCase();
		if(searchStr.indexOf(searchItm) > -1){
			return options.fn(this);
		}
	}

	return options.inverse(this);
});

Handlebars.registerHelper('global:dateExists', function (date, options) {
	return Utils.dateExists(date) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper("global:debug", function(optionalValue) {
	console.log("Current Context");
	console.log("====================");
	console.log(this);

	if (optionalValue) {
		console.log("Value");
		console.log("====================");
		console.log(optionalValue);
	}
});
Handlebars.registerHelper('global:formatDate', function(dateString, optionalNullReturnValue){
	// If this helper is called from a template with only the first parm (dateString)
	// Handlebars will pass an "object hash" object for the second parm (not undefined).
	if(dateString && dateString.trim() != ''){
		if (!Utils.dateExists(dateString)) {
			// Check for the existence of optionalNullReturnValue
			// by checking that it's type is string.
			if (typeof optionalNullReturnValue == 'string') {
				return optionalNullReturnValue;
			} else {
				return '';
			}
		}
		//var localDate = new Date(dateString);
		//return localDate.toLocaleDateString();
		return Utils.dateString(dateString);
	}
	return '';
});
Handlebars.registerHelper('global:formatDateTime', function(dateString, optionalNullReturnValue){
	// If this helper is called from a template with only the first parm (dateString)
	// Handlebars will pass an "object hash" object for the second parm (not undefined).
	if(dateString && dateString.trim() != ''){
		if (!Utils.dateExists(dateString)) {
			// Check for the existence of optionalNullReturnValue
			// by checking that it's type is string.
			if (typeof optionalNullReturnValue == 'string') {
				return optionalNullReturnValue;
			} else {
				return '';
			}
		}

		var formattedDateTime = Handlebars.helpers['global:formatDate'](dateString, optionalNullReturnValue) + ' ' +
								Handlebars.helpers['global:formatTime'](dateString, optionalNullReturnValue)

		return formattedDateTime;
	}
	return '';
});
Handlebars.registerHelper('global:formatMoney', function(money, editable, locale){
	if (money !== null && money != undefined && money !== '') {

    if(locale == null) {
      locale = Utils.getUserLang();
    }

    var formattedMoney = new Intl.NumberFormat(locale, {minimumIntegerDigits: 1,  minimumFractionDigits: 2, maximumFractionDigits: 2}).format(parseFloat(money));

    return i18n.t('CIVICS.COMMON.MONEY',{amount: formattedMoney});
	}
	return '';
});

Handlebars.registerHelper('global:formatMoneyNoTranslation', function(money, editable, locale){
	if (money !== null && money != undefined && money !== '') {

    if(locale == null) {
      locale = Utils.getUserLang();
    }

		return new Intl.NumberFormat(locale, {minimumIntegerDigits: 1, minimumFractionDigits: 2, maximumFractionDigits: 2}).format(parseFloat(money));
	}
	return '';
});

Handlebars.registerHelper('global:formatTime', function(dateString, optionalNullReturnValue){
	// If this helper is called from a template with only the first parm (dateString)
	// Handlebars will pass an "object hash" object for the second parm (not undefined).
	//
	// returns time as hh:MM tt   e.g.   09:15 AM
	//
	if(dateString  && dateString.trim() != ''){
		if (!Utils.dateExists(dateString)) {
			// Check for the existence of optionalNullReturnValue
			// by checking that it's type is string.
			if (typeof optionalNullReturnValue == 'string') {
				return optionalNullReturnValue;
			} else {
				return '';
			}
		}
		// var localTime = new Date(dateString);
		// var hours = localTime.getHours();
		// var minutes = localTime.getMinutes();
		// var ampm = hours >= 12 ? 'PM' : 'AM';
		// hours = (hours % 12);
		// hours = hours ? hours : 12; // the hour '0' should be '12'
		// minutes = minutes < 10 ? '0'+minutes : minutes;
		// debugger;
		// return hours + ':' + minutes + ' ' + ampm;
		return Utils.timeString(dateString);
	}
	return '';
});
Handlebars.registerHelper('global:getDateComponent', function (dateString) {
	if(typeof(dateString) === 'undefined' || !Utils.dateExists(dateString)) {
		return '';
	}
	var dt = dateString.split('T');
	return dt[0];
});
Handlebars.registerHelper('global:getTimeComponent', function (dateString) {
	if(typeof(dateString) === 'undefined' || !Utils.dateExists(dateString)) {
		return '';
	}
	var dt = dateString.split('T');
	return (dt.length > 1) ? dt[1].match(/^[0-9:]*/)[0] : '';
});
Handlebars.registerHelper('global:isEqual', function (obj1, obj2){
	return obj1 == obj2;
});
Handlebars.registerHelper('global:isUndefined', function(obj){
	return obj === undefined;
});
Handlebars.registerHelper('global:hasSelectedValue', function(values, selected){
	for (var i in values){
		if(values[i] == selected){
			return true;
		}
	}
	return false;
});
Handlebars.registerHelper('global:ifCond', function (v1, operator, v2, options) {
	switch (operator) {
		case '==':
			return (v1 == v2) ? options.fn(this) : options.inverse(this);
		case '!=':
			return (v1 != v2) ? options.fn(this) : options.inverse(this);
		case '===':
			return (v1 === v2) ? options.fn(this) : options.inverse(this);
		case '<':
			return (v1 < v2) ? options.fn(this) : options.inverse(this);
		case '<=':
			return (v1 <= v2) ? options.fn(this) : options.inverse(this);
		case '>':
			return (v1 > v2) ? options.fn(this) : options.inverse(this);
		case '>=':
			return (v1 >= v2) ? options.fn(this) : options.inverse(this);
		case '&&':
			return (v1 && v2) ? options.fn(this) : options.inverse(this);
		case '||':
			return (v1 || v2) ? options.fn(this) : options.inverse(this);
		default:
			return options.inverse(this);
	}
});

Handlebars.registerHelper('global:isLoggedInToOrganizationProfile', function (options) {
	if(App.user.isLoggedInToOrganizationProfile){
		return options.fn(this);
	}
	else {
		return options.inverse(this);
	};
});

Handlebars.registerHelper('global:math', function(lvalue, operator, rvalue) {
  lvalue = parseFloat(lvalue) || 0;
  rvalue = parseFloat(rvalue) || 0;
  return {
    "+": lvalue + rvalue,
    "-": lvalue - rvalue,
    "*": lvalue * rvalue,
    "/": lvalue / rvalue,
    "%": lvalue % rvalue
  }[operator];
});
Handlebars.registerHelper('global:limitLength', function(text,length,showMoreOrLess){
	if(typeof text != 'string'){ return i18n.t('CIVICS.COMMON.NO_TEXT_ERROR');}
	var ln = isNaN(length) ? 50:length;
	var showLink = (typeof showMoreOrLess === 'boolean') ? showMoreOrLess : false;
	var randID = Math.floor(Math.random()*100000);
	var code = {
		chopToLength:function(text,length){
			var chopped = text;
			if (text.length > length) {
				chopped = text.substring(0, length);
				return this.cleanUpEndofSmallText(chopped);
			}
			return text;

		},
		generateLengthLimitedText:function(){
			if(text.length<=ln){
				return text;
			}
			var shortVal = code.chopToLength(text,ln);
			if(showLink){
				return this.generateSpans(shortVal);
			} else {
				return shortVal;
			}
		},

		generateSpans:function(shortVal){
			var ret = '<span class="'+randID+'shortText">'+shortVal;
			ret+=' <a href="#" onClick="$(\'.'+randID+'shortText\').hide();$(\'.'+randID+'fullText\').show();return false;">'+i18n.t('CIVICS.COMMON.MORE')+'</a>';
			ret+='</span><span style="display:none;" class="'+randID+'fullText">'+text;
			ret+=' <a href="#" onClick="$(\'.'+randID+'fullText\').hide();$(\'.'+randID+'shortText\').show(); return false">'+i18n.t('CIVICS.COMMON.LESS')+'</a>';

			ret+='</span>';
			return ret;
		},
		cleanUpEndofSmallText:function(chopped){
			if(chopped.lastIndexOf(' ')>0){
				chopped = chopped.substring(0, chopped.lastIndexOf(' '));
			}
			chopped = chopped.trim();
			var last = chopped.charAt(chopped.length - 1)
			if (this.endCharsToRemove.indexOf(last)>=0) {
				chopped = chopped.substring(0, chopped.length - 1);
			}
			chopped += '...';
			return chopped;
		},
		endCharsToRemove:[
			';',
			':',
			'.',
			',',
			'!',
			'?'
		]
	}
	return code.generateLengthLimitedText();

});
//replacement string should either be br(for read only) or \lf (for edit mode)depending on scenario.
//this function will strip all HTML from the string, and replace all <div> <br> and \lf \cr \nl with the replacement string.
//IPS uses <br> in HTML Areas, and LF in text areas. Rhythm uses BR in read only mode, and LF in edit mode text areas.
//we have no weay to tell which type the field is, so we're defaulting to text area support first (sending LF back to the server)
Handlebars.registerHelper('global:prepareMultilineValue', function (text, replacementString) {
	if (text != undefined) {
		if (_.isNumber(text)) {
			return text;
		}
		else {
			//remove inline closing tags so they don't get turned into line breaks
			var inlines = ['span', 'em', 'i', 'b', 'strong', 'span', 'a', 'font'];
			var reg;
			$.each(inlines, function (index, tag) {
				reg = new RegExp('<\/' + tag + '\s*\/?>', 'gi');
				text = text.replace(reg, ' ');
			});

			//replace &gt; and &lt;
			text = text.replace(/&gt;/g, '>');
			text = text.replace(/&lt;/g, '<');

			//replace BRs
			text = text.replace(/<br\s*\/?>/gi, '__LINE__BREAK__');
			//replace <???> opening tags only
			text = text.replace(/(<[^<>]*>)+/gi, '__LINE__BREAK__');
			//replace line feed, carriage return, newline
			text = text.replace(/(?:\r\n|\r|\n)/g, '__LINE__BREAK__');
			//reduce the number of duplicate line breaks caused by a div followed by a br
			text = text.replace(/__LINE__BREAK____LINE__BREAK__/gi, '__LINE__BREAK__');
			text = text.replace(/__LINE__BREAK____LINE__BREAK__/gi, '__LINE__BREAK__');
			//remove all HTML tags
			//var rex = /(<([^>]+)>)/ig;
			//text = text.replace(rex , ' ');
			var temp = document.createElement("div");
			temp.innerHTML = dompurify.sanitize(text);
			text = temp.textContent || temp.innerText;

			return text.replace(/__LINE__BREAK__/g, replacementString);
		}
	}
	return '';
});

//function to get a string based on what profile the user is using (e.g. Org, AU, personal)
Handlebars.registerHelper('global:profileString', (localizationName, ...args) => {	
	return authorized_user_utils.profileString(localizationName, args);
});

Handlebars.registerHelper('global:radioInputChecked', function(currCode, selected) {
		return (currCode === selected) ? 'checked' : '';
});
Handlebars.registerHelper('global:removeHTML', function(text, removeLineBreaks){
	// to consider number value to be valid
    if(text != undefined){
		if ( _.isNumber(text) ){
			return text;
		}
		else {
			if(removeLineBreaks !== true){
				//remove inline closing tags so they don't get turned into line breaks
				var inlines = ['span','em','i','b','strong','span','a','font'];
				var reg;
				$.each(inlines,function(index, tag){
					reg = new RegExp('<\/'+tag+'\s*\/?>','gi');
					text = text.replace(reg,' ');
				});

                //replace &gt; and &lt;
                text = text.replace(/&gt;/g, '>');
                text = text.replace(/&lt;/g, '<');

				//replace BRs
				text = text.replace(/<br\s*\/?>/gi,'__LINE__BREAK__');
				//replace </???> closing tags only
				text = text.replace(/(<\/[^<>]*>)+/gi,'__LINE__BREAK__');
				//reduce the number of duplicate line breaks caused by a div followed by a br
				text = text.replace(/__LINE__BREAK____LINE__BREAK__/gi,'__LINE__BREAK__');
			}
			//remove all HTML tags
			//var rex = /(<([^>]+)>)/ig;
			//text = text.replace(rex , ' ');
			var temp = document.createElement("div");
			temp.innerHTML =  dompurify.sanitize(text);
			text = temp.textContent || temp.innerText;

			return text.replace(/__LINE__BREAK__/g,'<br />');
		}
	}
	return '';
});
Handlebars.registerHelper('global:removeTimeZone', function(dateString){
	return Utils.removeTimeZone(dateString);
});
Handlebars.registerHelper('global:replaceCRLFs', function(text){
	if(text){
		// Replace Carriage Return Line Feed variants with HTML BR tags.
		// When using in handlebars template use triple {{{}}} to wrap your field
		var rexCRLFs = /\r?\n|\r/g;
		return text.replace(rexCRLFs, '<br />');
	}
	return '';
});
Handlebars.registerHelper('global:selectInputSelected', function(currCode, selected) {
	return (currCode === selected) ? 'selected' : '';
});
Handlebars.registerHelper('global:concat', function() {
	var outStr = '';
	for(var arg in arguments){
		if(typeof arguments[arg]!='object'){
			outStr += arguments[arg];
		}
	}
	return outStr;
});
Handlebars.registerHelper('global:tooltipAttribute', function(attr) {
	return "data-toolTip=\""+attr+"\"";
});
Handlebars.registerHelper('global:pluralize', function(count,singular,plural) {
    if(count==1){
      return singular;
    } else {
      return plural;
    }
});
Handlebars.registerHelper('global:decodeHTMLEntities', function(value) {
  return $("<div/>").html(value).text();
});
Handlebars.registerHelper('global:encodeName', function() {
  var outStr = '';
	for(var arg in arguments){
		if(typeof arguments[arg]!='object' && arguments[arg] !== undefined){
      var argsString = arguments[arg].toString();
			outStr += (argsString.replace(/[^A-Z0-9]/ig, "_")).substring(0, Math.min(argsString.length, 50));
		}
	}
	return outStr;
});
Handlebars.registerHelper('global:sanitize', function (value) {
	var options = arguments.length > 1 ? arguments[arguments.length - 1] : {};
	var hash = options.hash || {};
	var config = {};

	if ('allowedTags' in hash) {
		config.ALLOWED_TAGS = hash.allowedTags === '' ? [] : hash.allowedTags.split(',');
	}

	if ('addAttr' in hash) {
		config.ADD_ATTR = hash.addAttr === '' ? [] : hash.addAttr.split(',');
	} else {
		config.ADD_ATTR = ['target'];
	}

	return dompurify.sanitize(value, config);
  });
